<template>
  <div>
    <b-row>
      <b-col v-for="item in list" :key="item.id" cols="12" style="padding: 0;" @click="goDetail(item)">
        <b-card class="news-card border-1">
          <b-row>
            <b-col cols="9">
              <div style="display: flex;flex-direction: column;justify-content: space-between;height: 100%;">
                <h4 class="news-title">{{ item.title }}</h4>
                <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
                  <p class="news-time">{{ item.create_time }}</p>
                  <div style="display: flex;justify-content: center;">
                    <p class="news-time" v-for="(val,key) in item.subjects" @click.stop="goZhuan(val)">
                      {{ val.title }}<b-icon icon="bookmark-fill" style="color: #FFBA01;"></b-icon>
                    </p>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <b-img :src="item.logo" alt="图片加载失败" fluid></b-img>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    props: ['list'],
    data() {
      return {
        // newsList: this.list
      }
    },
    methods: {
      goZhuan(item) {
        console.log(item);
        this.$router.push({
          name: 'zhuanti',
          params: {
            id: item.id,
          }
        })
      },
      goDetail(item) {
        this.$router.push({
          name: 'normalDetail',
          params: {
            id: item.id
          }
        })
      }
    }
  }
</script>

<style>
  .news-card {
    margin-bottom: 20px;
  }

  .news-title:hover {
    color: red;
    cursor: pointer;
  }

  .news-time:hover {
    color: red;
    cursor: pointer;
  }

  .news-title {
    margin-top: 0;
  }

  .news-time {
    margin-bottom: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/normalList/normalList.vue